import { jobStatusNames } from '../../common/constants/jobStatusNames';

// SC-QA-53: Verification and Done email the customer that the report is ready, so the report must exist first. The same
// rule as dealer-api `src/jobs/helpers/report-readiness.ts`, which refuses the change with 400 `REPORT_NOT_READY`.

const READY_REPORT_STATUSES = [jobStatusNames.Verification, jobStatusNames.Done];
// before Processed nothing has asked the parser yet
const NOT_SENT_TO_PARSER = [jobStatusNames.New, jobStatusNames.InProgress];

export const needsReadyReport = statusName => READY_REPORT_STATUSES.includes(statusName);

/**
 * `ready`, or why not: `no_report_file`, `not_parsed` (never moved to Processed) or `parsing` (still running). Every
 * finished parse counts, with or without a parsed report. `files` overrides `job.files` (Order Preview fetches its own).
 */
export const getReportReadiness = (job, files = job?.files) => {
    if (!files?.some(file => file.fileName.includes('report'))) {
        return 'no_report_file';
    }

    if (job?.report || job?.error?.isParserReportReady || job?.error?.isParserError) {
        return 'ready';
    }

    return NOT_SENT_TO_PARSER.includes(job?.status?.name) ? 'not_parsed' : 'parsing';
};

/** The reason the API gave for refusing Verification or Done, or null for any other error. */
export const reportNotReadyReason = error => {
    const data = error?.response?.data;

    return data?.code === 'REPORT_NOT_READY' ? data.reason : null;
};
